<template>
  <div :class="['w-full', computed_aspect]" v-html="embed_src"></div>
</template>

<script>

export default {
  components: {

  },
  props: {
  	src: {
  		video_type: String
  	},
		aspect: {
			type: String,
			default: '16-9'
		}
  },
  data() {
    return {
    	video_type: false,
    	embed_src: ""
    }
  },
  created() {
  	if (this.src.indexOf("youtube") >= 0 || this.src.indexOf("youtu.be") >= 0) {
  		this.video_type = "youtube";
  		this.embed_src = this.convert_youtube(this.src);
		} else if (this.src.indexOf("vimeo") >= 0) {
			this.video_type = "vimeo";
  		this.embed_src = this.convert_vimeo(this.src);
		} else {
  		this.video_type = "mp4";
  		this.embed_src = this.convert_html5(this.src);
  	}
  },
  methods: {
    convert_youtube(input) {
		  var pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(\S+)/g;
		  if (pattern.test(input)) {
		    var replacement = '<iframe src="https://www.youtube.com/embed/$1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
		    var input = input.replace(pattern, replacement);
		    // For start time, turn get param & into ?
		    var input = input.replace('&amp;t=', '?t=');
		  }
			console.log('VIDEO2',input);
		  return input;
		},
		convert_vimeo(input) {
		  var pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(\S+)/g;
		  if (pattern.test(input)) {
		   var replacement = '<iframe src="https://player.vimeo.com/video/$1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
		   var input = input.replace(pattern, replacement);
		  }
		  return input;
		},
		convert_html5(input) {
			return '<video src="'+input+'" controls autoplay playsinline></video>';
		}
  },
	computed: {
		computed_aspect() {
			if (this.aspect == '9-16') {
				return 'aspect-w-9 aspect-h-16';
			}
			return 'aspect-w-16 aspect-h-9';
		}
	}
}
</script>
